import { LegConnectorConnectionType } from '@lp/features/RoutePlanner/types';
import { LegConnector } from '@lp/features/RoutePlanner/components/RouteViewList/LegConnector';
import { AviaLegTypes, GroundLegTypes } from '@/api/apis/route';
import { RouteSegmentType } from '@/types/route';
import { LegDetails } from './LegDetails/LegDetails';

type CaseLogisticsLegProps = {
  segment: RouteSegmentType;
  leg: AviaLegTypes | GroundLegTypes;
  showBottomConnector: boolean;
};

export const CaseLogisticsLeg = ({ segment, leg, showBottomConnector }: CaseLogisticsLegProps) => {
  const isStartLocation = leg.departureLocation.locationId === segment.startLocation.id;
  const isEndLocation = leg.arrivalLocation.locationId === segment.endLocation.id;

  return (
    <div className="flex items-stretch gap-3">
      <LegConnector
        type={leg.legType}
        startConnection={isStartLocation ? LegConnectorConnectionType.startToEnd : LegConnectorConnectionType.inbetween}
        endConnection={isEndLocation ? LegConnectorConnectionType.startToEnd : LegConnectorConnectionType.inbetween}
        segmentType={leg.segmentType}
        showBottomConnector={showBottomConnector}
        showAddLegButton={false}
      />
      <LegDetails leg={leg} />
    </div>
  );
};
